
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top/popular",
      function () {
        return require("private-next-pages/top/popular.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top/popular"])
      });
    }
  